export default "__VITE_ASSET__CYgyWH4j__"